import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";

/**
 * Generated class for the AppPopupEvaluationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-popup-evaluation',
  templateUrl: 'app-popup-evaluation.html',
})
export class AppPopupEvaluationPage {

  response: number;
  secondVersion: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public api: ApiProvider, public userState: UserStateProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPopupEvaluationPage');

    if(this.navParams.data.type == 'second') {
      this.secondVersion = true;
    }
  }

  saveData() {
    if(this.response == 1) {
      this.api.callPost('/users/' + this.userState.user.id + "/evaluation", {}).subscribe(() => {
        console.log('evaluation mail sent');
      });
    }

    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-popup-evaluation/app-popup-evaluation.ts